// filepath: apps/web/src/features/admin/effects/PendingReviewBanner.tsx
//
// FR-UI-ADM-8 -- pending-promotion-review banner for the effects
// admin editors. Shows when there are pending reviews for the
// given def_type (http_endpoint or email_channel).

import React from "react";

interface PendingReviewBannerProps {
  /** "http_endpoint" | "email_channel" */
  defType: string;
}

export function PendingReviewBanner({
  defType,
}: PendingReviewBannerProps): React.ReactElement | null {
  // v1: banner is static until the promotion-reviews query is wired.
  // FR-UI-PROM-2 provides the review gate that this banner links to.
  // The pending count will be wired in a follow-up via the same
  // usePromotionPendingCount pattern from the webhooks banner.
  void defType; // suppress unused-var lint until query is wired
  return null;
}
